import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import BabyPiercingImage from '../../Assets/ImgAi/baby_piercingai2.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function BabyPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
            <title>Baby Ear Piercing Dubai, UAE </title>
            <meta
                name="description"
                content="Baby Ear Piercing Dubai, UAE with a safe and gentle approach by trained professionals, using quality products and hygienic piercing practices. Book today."
            />
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Baby Ear Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Baby Ear Piercing 150-200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={BabyPiercingImage} alt="Baby Ear Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Baby Ear Piercing</h3>

          <p>
            Ensure your little one’s first piercing experience is safe, gentle, and stress-free with our professional baby ear piercing services in the UAE, priced affordably between 150–200 AED. We specialize in infant and baby ear piercing, following the highest hygiene and safety standards to provide parents with complete peace of mind. Our trained and certified specialists use sterile, single-use equipment and medical-grade techniques to ensure a clean and infection-free procedure.
          </p>

          <p>
            Baby ear piercing requires extra care and precision, and our experienced team is dedicated to delivering a quick, smooth, and comfortable experience with minimal discomfort for your child. Our baby-friendly environment is designed to keep both parents and infants relaxed throughout the process. We understand that babies can be sensitive, which is why we focus on gentle handling, calm surroundings, and efficient procedures to reduce stress and ensure a positive experience.
          </p>

          <p>
            Our specialists are skilled in positioning and piercing techniques that are safe for delicate baby earlobes, ensuring accurate placement and minimal irritation. The entire process is completed within minutes, making it convenient and hassle-free for busy parents.
          </p>

          <p>
            We also provide detailed aftercare guidance to help you take proper care of your baby’s newly pierced ears. Proper aftercare is essential for quick healing and preventing infections, and our team will guide you on cleaning routines, recommended products, and what to expect during the healing period. We are always available to answer any questions or concerns you may have, ensuring that you feel confident in caring for your baby’s ears after the procedure.
          </p>

          <p>
            Our baby ear piercing services in the UAE are trusted by many families for our commitment to safety, hygiene, and professionalism. We use high-quality, hypoallergenic starter earrings that are specially designed for babies to prevent irritation and allergic reactions. Whether you are choosing ear piercing for cultural, traditional, or personal reasons, we ensure that your child receives the best care possible in a clean and welcoming environment.
          </p>

          <p>
            Affordability meets premium service with our competitive pricing, making safe baby ear piercing accessible without compromising on quality. Booking an appointment is simple and convenient, allowing you to choose a time that suits your schedule. We prioritize minimal waiting times and a smooth experience from start to finish, so you and your baby can feel comfortable and well cared for.
          </p>

          <p>
            Choose our expert baby ear piercing services in the UAE for a safe, hygienic, and gentle experience that prioritizes your child’s comfort and well-being. With our experienced professionals, sterile procedures, and caring approach, we make your baby’s first ear piercing a positive and memorable milestone. Book your baby ear piercing appointment today and experience trusted, high-quality service designed especially for your little one.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Baby Ear Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default BabyPiercing;